import '@hapana/shared/utils/type-defs.util'

/** @type {Styles} */

export const styles = {
  headerWrapper: {
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  userInfoWrapper: {
    display: 'flex',
    alignItems: 'center',
  },
  dot: {
    marginLeft: 0.5,
    marginRight: 0.5,
  },
  username: {
    marginLeft: 2,
  },
  noteTypeWrapper: {
    paddingTop: 2,
    paddingBottom: 2,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  notesTypeContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  separator: {
    color: 'gray.40',
  },
  viewAllType: {
    cursor: 'pointer',
    color: 'primary.main',
  },
  showAllContainer: {
    paddingLeft: 4,
    paddingRight: 4,
    paddingTop: 2,
    paddingBottom: 2,
  },
  hide: {
    display: 'none',
  },
  notesContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'baseline',
    marginBottom: 2,
  },
  date: {
    marginTop: 1,
    marginRight: 1,
  },
  tabs: {
    marginLeft: 2,
  },
  chipContainer: {
    display: 'inline-flex',
    marginTop: 0.75,
    marginLeft: 0.5,
  },
  notewithBadgeContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  noteDetailContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: 1.5,
  },
  alertHeaderContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  filterContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  description: {
    maxWidth: {
      xs: '95%',
      md: 485,
    },
  },
  propertyTitle: {
    marginBottom: 0.5,
  },
  propertyDescription: {
    marginBottom: 2.5,
  },
  showAllNotesText: {
    marginTop: 0.75,
    marginRight: 0.75,
  },
  totalNotes: {
    marginTop: 0.75,
  },
  alertHeaderflex: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'start',
  },
  alertHeaderDescriptionWrapper: {
    marginLeft: 2,
  },
  alertHeaderflexContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  paymentContainerShift: {
    paddingLeft: 4.5,
  },
  paymentType: {
    marginLeft: 1.5,
  },
  paymentsWrapper: {
    marginLeft: 1,
  },
  deleteNoteText: {
    textAlign: 'center',
  },
  deleteNoteIcon: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: 2,
  },
  noteActionOption: {
    marginLeft: 2,
  },
  suspendedClientDescription: {
    display: 'flex',
  },
  individualPaymentWrapper: {
    paddingLeft: 5,
  },
  chipStyle: {
    marginRight: 0.5,
  },
  titleSection: {
    flex: 'none',
    paddingX: 4,
  },
  notesTypeWrapper: {
    paddingX: 4,
  },
  editIcon: {
    width: 16,
    height: 16,
    color: 'gray.56',
  },
  optionIcon: {
    cursor: 'pointer',
    color: 'gray.64',
  },
  openNote: {
    marginTop: 0.5,
    width: 18,
    height: 18,
    color: 'gray.56',
  },
  deleteNote: {
    marginTop: 0.5,
    width: 18,
    height: 18,
    color: 'gray.56',
  },
  openNoteDescription: {
    marginLeft: 0,
  },
  emptyNotesIcon: {
    color: 'gray.16',
    width: 32,
    height: 32,
    marginBottom: 1.8,
  },
  emptyStateContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    paddingBottom: 2.75,
  },
}
